import { KretskampenApp } from '@/components/features/quiz/KretskampenApp';

export function KretskampenPage() {
  return (
    <div className="flex-1 overflow-y-auto">
      <KretskampenApp />
    </div>
  );
}
